var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "panoTinyVideo",
      attrs: {
        id: `smallVideo-${_vm.user.userId}-${
          _vm.showScreenShare ? "screen" : "video"
        }`,
      },
    },
    [
      _c("div", {
        ref: "domRef",
        staticClass: "videoDomRef",
        style: {
          visibility: `${
            (_vm.showScreenShare && !_vm.user.screenOpen) ||
            (!_vm.showScreenShare && _vm.user.videoMuted)
              ? "hidden"
              : "visible"
          }
      ${
        _vm.isUserMe
          ? "transform: rotateY(180deg)" // 本地预览翻转
          : ""
      }`,
        },
      }),
      _vm._v(" "),
      _vm.user.videoMuted
        ? _c(
            "div",
            {
              staticClass: "userNameMainView",
              staticStyle: { "font-size": "24px" },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.user.userName || _vm.user.userId) +
                  "\n    " +
                  _vm._s(_vm.isUserMe ? "(Me)" : "") +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isUserMe
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.controlId == _vm.user.userId,
                  expression: "controlId == user.userId",
                },
              ],
              staticClass: "control",
            },
            [
              _c(
                "div",
                { staticClass: "t_control" },
                [
                  _c("span", [_vm._v("Me：")]),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: "摄像头开关",
                        placement: "top",
                        effect: "light",
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: _vm.user.videoMuted
                            ? _vm.videoIcon[1]
                            : _vm.videoIcon[0],
                        },
                        on: { click: _vm.onClickCamMute },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: "麦克风开关",
                        placement: "top",
                        effect: "light",
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: _vm.user.audioMuted
                            ? _vm.audioIcon[1]
                            : _vm.audioIcon[0],
                        },
                        on: { click: _vm.onClickMicMute },
                      }),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "userVideoStatus" }, [
        !_vm.user.videoMuted || _vm.showScreenShare
          ? _c("div", { staticClass: "userVideoUserName" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.user.userName || _vm.user.userId) +
                  "\n      " +
                  _vm._s(_vm.showScreenShare ? "(Share)" : "") +
                  "\n      " +
                  _vm._s(_vm.isUserMe ? "(Me)" : "") +
                  "\n    "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.user.audioMuted
          ? _c("i", {
              staticClass: "iconfont icon-microphone-slash",
              style: { color: "red", fontSize: "14px", position: "static" },
            })
          : _c("i", {
              staticClass: "iconfont icon-microphone",
              style: {
                color: _vm.user.isSpeaking ? "#00ff00" : "#fff",
                fontSize: "14px",
                position: "static",
              },
            }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/components/userVideo/SmallView.vue?vue&type=template&id=4d6d26ca&
// module id = null
// module chunks = 